var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 574,
    viewBox: "0 0 1440 574",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 574L1392 535.793C1344 496.869 1248 421.531 1152 382.607C1056 344.4 960 344.4 864 296.507C768 249.331 672 152.469 576 114.8C480 77.1312 384 95.0688 288 86.1C192 77.1312 96 37.6688 48 19.1931L0 0V574H48C96 574 192 574 288 574C384 574 480 574 576 574C672 574 768 574 864 574C960 574 1056 574 1152 574C1248 574 1344 574 1392 574H1440Z",
    fill: "#00BF62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.5148c007154019bc367f338a623a39f0.svg";
export { ForwardRef as ReactComponent };